<script lang="ts">
import type { Snippet } from 'svelte'
import type { HTMLSelectAttributes } from 'svelte/elements'

import { isDesktop } from '@/modules/device'

type Props = {
	value?: string
	placeholder?: string
	isInvalid?: boolean
	testId?: string
	children?: Snippet
	onChange?: (event: Event) => void
	onBlur?: (event: Event) => void
} & Omit<HTMLSelectAttributes, 'value'>

let {
	value = $bindable(''),
	placeholder,
	isInvalid = false,
	testId,
	children,
	onChange,
	onBlur,
	...rest
}: Props = $props()
</script>

<select
	bind:value
	aria-invalid={isInvalid || undefined}
	onchange={onChange}
	onblur={onBlur}
	{...rest}
	class={[
		'block w-full h-10 px-3 py-2 bg-white text-base-input text-slate-800 border border-slate-200 rounded-xl',
		$isDesktop && 'text-sm',
		isInvalid && 'invalid',
	]}
	data-testid={testId}
>
	{#if placeholder}
		<option value="">{placeholder}</option>
	{/if}
	{@render children?.()}
</select>

<style lang="postcss">
select {
	appearance: none;
	background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 20 20'%3E%3Cpath stroke='%236B7280' stroke-linecap='round' stroke-linejoin='round' stroke-width='1.5' d='m6 8 4 4 4-4'/%3E%3C/svg%3E");
	background-position: right 0.5rem center;
	background-repeat: no-repeat;
	background-size: 1.5em 1.5em;
}

.invalid {
	@apply border-red-500;
}
</style>
